import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getCarHireItemsView } from 'checkout/selectors/view/carHire'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/getPromoKeyForLoyaltyItem'

const getCheckoutCarHirePointsCalculationRequests = createSelector(
  (state: App.State) => getCarHireItemsView(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (carHireViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!carHireViews.hasRequiredData) return EmptyArray

    return carHireViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => {
      // Taxes and Fees are due at Pickup, so are not accounted for points
      const basePrice = itemView.totals.price + (itemView.item?.selectedInsurance?.total ?? 0) - itemView.totals.taxesAndFees
      const payOnArrivalPrice = itemView.totals?.carHirePayOnArrival ?? 0
      return {
        price: basePrice - payOnArrivalPrice,
        loyaltyProductType: 'car_hire',
        itemId: itemView.item.itemId,
        earnKey: itemView.item.loyaltyBonusPointsEarnKey,
        promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId: itemView.item.itemId } }),
      }
    })
  },
)

export default getCheckoutCarHirePointsCalculationRequests
